import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
  MenuList,
  MenuItem,
  Td,
  Tr,
  Textarea,
  Card,
  CardBody,
  Divider,
  Input,
  SimpleGrid,
  Center,
  RadioGroup,
  Stack,
  Radio,
  Th,
  Collapse,
  useDisclosure,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import {
  DropdownInput,
  PasswordInput,
  PrimaryInput,
  PrimaryInputDropdown,
  SearchBar,
  Toaster,
} from "../../components";

import { BrowserRouter as Router, useNavigate } from "react-router-dom";

import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import {
  formatDate_DD_MM_YYYY,
  formatDate_YYYY_MM_DD,
  getAddressInfo,
  getCroppedImg,
  getCurrency,
  getHospitalName,
  getLoginID,
  getLogo,
  getUniqueNames,
  handleAlphaDotAndSpace,
  handleNumericDotAndSpace,
  useScreenType,
} from "../../auth";
import {
  AddReferHospitals,
  DeleteReferHospitals,
  GetReferHospitals,
  UpdateReferHospitals,
} from "../../middleware/services/referhospitals";
import {
  addClinic,
  addPharmacy,
  deletePharmacy,
  FetchDoctorClinics,
  FetchTransferMedicineList,
  GenerateMedicineRequest,
  getBatchNumbers,
  getPharmacy,
  getProfile,
  getURN,
  saveClinicChanges,
  saveClinicDeletedChanges,
  saveClinicEditedChanges,
  saveMedicineTransfer,
  updateClinic,
  updatePartnerLogoOnChange,
  updatePharmacy,
  uploadPartnerImageInProfile,
} from "../../middleware/services/profile";
import ImageCropper from "../profile/ImageCropper";
import { format } from "date-fns";
import DatePicker from "../../components/date-picker";
import TransferIndex from "../inventory/transfermedicines";
import moment from "moment";
import { FetchInvoice } from "../../middleware/services/billing";

const PharmacyIndex = () => {


const initialRow = {
  medicinename: '',
  medicinenamedisplay: '',
  batchnumber: '',
  mrp: '',
  quantity: '',
  totalamount: '',
  inventoryid: '',
  prescriptionid: '',
  labname: '',
  doctorname: '',
  remainingquantity:'',
  totalCgst:'',
  totalSgst:'',
  sgst:'',
  cgst:'',
  dosage: '',
  dosageunit: '',
  medicinetype: '',
};

  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();

  const screenType = useScreenType();
  const navigate = useNavigate();
  const [resultPharmacy, setResultPharmacy] = useState([]);
  const [pharmacyData, setPharmacyData] = useState([]);

  const [pharmacyName, setPharmacyName] = useState(null);
  const [pharmacyType, setPharmacyType] = useState("null");
  const [pharmacyLocation, setPharmacyLocation] = useState("");

//   const [branchAddress1, setBranchAddress1] = useState(null);
//   const [branchAddress2, setBranchAddress2] = useState(null);
//   const [branchCity, setBranchCity] = useState(null);
//   const [branchState, setBranchState] = useState(null);
//   const [branchPinCode, setBranchPinCode] = useState(null);
//   const [branchCountry, setBranchCountry] = useState(null);

  const [genderId, setGenderId] = useState(null);
  const [branchid, setbranchid] = useState(null);
  const [refreshPageData, setRefreshPageData] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [Address, setAddressDetails] = useState([]);
  const [hospitalname, setHospitalName] = useState("");
  const [hospitallogo, setHospitalLogo] = useState("");
  const [currency, setCurrency] = useState("");
  const [medicineList, setMedicineList] = useState([]);
  const [ShowPrescription, setShowPrescription] = useState(true);
  const [InvoiceNumber, setInvoiceNumber] = useState(null);
  const [rows, setRows] = useState([initialRow]);
  const [ inputId , setInputId ] = useState("");
  const [batchData, setBatchData] = useState([]); 
  const [batchNums, setBatchNums] = useState([]); 
  const [showBatchDropdown, setShowBatchDropdown] = useState(-1);
  const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] = useState(-1);
  const [boolValForSuggestions, setBoolValForSuggestions] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [transferMedicineName, setTransferMedicineName] = useState("")
  const [focusedItemIndex, setFocusedItemIndex] = useState(-1);
  const [rowToDelete, setRowToDelete] = useState(null);
    const [QuantityInStrip, setQuantityInStrip] = useState(0);
  const [requestMedicineData, setRequestMedicineData] = useState({
    urnNumber: "",
    date: "",
    inputDate: "",
    initiatedBy: "",
    pharmacyList: [],
    pharmacyName: "",
  });
  const [selectedPharmacy, setSelectedPharmacy] = useState({
    pharmacyname: "",
    pharmacyid: "",
  });
  const { isOpen, onToggle } = useDisclosure()

  const addPharmacyModal = useRef();
  const editPharmacyModal = useRef();
  const deletePharmacyModal = useRef();
  const openReqModal = useRef();
  const medicineRef = useRef();
  const suggestionsMenuRef = useRef(null);
  const quantityRef = useRef(null);
  const deleteRowModal = useRef();

  const getPharmacyList = async () => {
    // var inputForGet = {
    //     "pharmacyname": pharmacyName,
    //     "searchtext": "Pharmacy"
    // };
    var inputForGet = {};
    showLoader();
    try {
      var result = await getPharmacy(inputForGet);

      if (result && result.output.data) {
        setResultPharmacy(result.output.data);
        setPharmacyData(result.output.data);
        // console.log(result.output.data, "result of doctor profile");
      }else {
        setResultPharmacy([])
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };
  
  const getPharmacyListForReq = async () => {
    // var inputForGet = {
    //     "pharmacyname": pharmacyName,
    //     "searchtext": "Pharmacy"
    // };
    var inputForGet = {};
    showLoader();
    try {
      var result = await getPharmacy(inputForGet);

      if (result && result.output.data) {
        setResultPharmacy(result.output.data);
        setPharmacyData(result.output.data);
        // console.log(result.output.data, "result of doctor profile");
      }else {
        setResultPharmacy([])
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };

  useEffect(() => {
    getPharmacyList();
  }, [refreshPageData]);

//  ---------------------------- Add Functionality Start --------------------------------

  function clearState() {
    setPharmacyName(null);
    setPharmacyType("")
    setPharmacyLocation("")
  }

  const openAddPharmacyModal = () => {
    clearState();
    addPharmacyModal.current.openRight();
  };

  async function addPharmacyFunction() {
    if (!pharmacyName) {
      showErrorToast("Please Enter Pharmacy Name!");
      return false;
    } else if (!pharmacyType) {
      showErrorToast("Please select Pharmacy Type!");
      return false;
    } else if (!pharmacyLocation) {
      showErrorToast("Please select Pharmacy Location!");
      return false;
    }
    showLoader();
    let addPharmacyInput = {
      "pharmacyname": pharmacyName,
      "pharmcytype": pharmacyType,
      "locationname": pharmacyLocation,
    };
    try {
      let result = await addPharmacy(addPharmacyInput);
      // console.log(result, " result of add branch.");
      if (result.output.result == "success") {
        showSuccessToast("Pharmacy added Successfully!");
        setRefreshPageData(!refreshPageData);
        addPharmacyModal.current.closeRight();
      }else {
        showErrorToast("Something went Wrong!");
      }
    } catch (error) {
      console.log(error, " error in creating pharmacy");
    }
    dismissLoader();
  }

//  ---------------------------- Add Functionality end --------------------------------

//  ---------------------------- Edit Functionality start --------------------------------

const [editid, setEditid] = useState("")
const [pharmacyTypeFilter, setPharmacyTypeFilter] = useState("")

function openEditPharmacy(item) {
  setEditid(item.id);
  setPharmacyName(item.pharmacyname);
  setPharmacyType(item.pharmcytype);
  setPharmacyLocation(item.locationname)

  editPharmacyModal.current.openRight();
}

  async function editPharmacyFunction() {
    if (!pharmacyName) {
      showErrorToast("Please Enter Pharmacy Name!");
      return false;
    } else if (!pharmacyType) {
      showErrorToast("Please select Pharmacy Type!");
      return false;
    } else if (!pharmacyLocation) {
      showErrorToast("Please select Pharmacy Location!");
      return false;
    }
    showLoader();
    let editPharmacyInput = {
      "id": editid,
      "pharmacyname": pharmacyName,
      "pharmcytype": pharmacyType,
      "locationname": pharmacyLocation,
    };
    try {
      let result = await updatePharmacy(editPharmacyInput);
      // console.log(result, "resutl of edit")

      if (result.output.result == "success") {
        showSuccessToast("Pharmacy updated Successfully!");
        setRefreshPageData(!refreshPageData);
        // addPharmacyModal.current.closeRight();
        editPharmacyModal.current.closeRight();
        getPharmacyList();
      } else {
        showErrorToast("Something went Wrong!");
      }
    } catch (error) {
      console.log(error, " error in editing branch");
    }

    // console.log(input , " add branch input")

    dismissLoader();
  }

//  ---------------------------- edit Functionality end --------------------------------


  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@._-]/g, "").slice(0, 50);
    setSearchValue(inputValue);
  };

  async function handleFilter() {
    // const trimmedName = searchValue?.trim();
    const trimmedName = searchValue;
    const inputToFetch = {
      input: {
        // doctorid: getLoginID(),
        // searchtext: trimmedName,
        "pharmacyname": trimmedName,
        "pharmcytype": pharmacyTypeFilter
      },
    };
    showLoader();
    try {
      const result = await getPharmacy(inputToFetch.input);
      if (result && result.output.data) {
        setResultPharmacy(result.output.data);
      }
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };

  async function resetFeilds() {
    setSearchValue("");
    setPharmacyTypeFilter("")
    getPharmacyList();
  }

  const handlepharmacytypechangeforfilter = (selectedOption) => {
    // console.log('selectedOptions : ', selectedOption)
    if(selectedOption === "IPD"){
      setPharmacyTypeFilter("IPD")
    } else if(selectedOption === "OPD") {
      setPharmacyTypeFilter("OPD")
    }
  };
  // const handlepharmacytypechange = (selectedOption) => {
  //   // console.log('selectedOptions : ', selectedOption)
  //   if(selectedOption === "IPD"){
  //     setPharmacyType("IPD")
  //   } else {
  //     setPharmacyType("OPD")
  //   }
  // };
  const handlepharmacytypechange = (values) => {
    if (values.includes("IPD")) {
      setPharmacyType("IPD");
    }else if(values.includes("OPD")) {
      setPharmacyType("OPD")
    }
    
  };

  const [deleteid, setDeleteid] = useState("")

  const openDeletePharmacyModal = (step) => {
      setDeleteid(step.id);
      setPharmacyName(step.pharmacyname);
      deletePharmacyModal.current.openModal();
    };
  
    const deletePharmacyInput = {
      "id": deleteid,
    };
    const deletePharmacyFromList = async () => {
      try {
        const result = await deletePharmacy(deletePharmacyInput);
  
        if (result.output.message === "Successfully Deleted") {
          showSuccessToast("Pharmacy Deleted Successfully");
          deletePharmacyModal.current.closeModal();
          getPharmacyList();
        }
      } catch (error) {
        console.log(error, "Something went wrong in doctor profile");
      }
    };

    const addTransferModal = useRef();

    const openTransferModal = () => {
      // clearState();
  
      addTransferModal.current.openRight();
    };

    const fetchMedicines = async () => {
      try {
        const result = await FetchTransferMedicineList({
          doctor:'',
          type:"catalog"
          });
        if (result.output.data.length > 0) {
          setMedicineList(result.output.data);
          setShowPrescription(true);
        }
        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
    };

    const fetchInvoiceNumber = async () => {
      try {
        const result = await FetchInvoice({ 
          doctorid: '',
         });
        if (result.output.invoicenumber) {
          setInvoiceNumber(result.output.invoicenumber)
        }

        dismissLoader();
      } catch (error) {
        console.error("Error in home:", error);
      }
    };

    const AddAnotherRowPrescription = () => {
      const initialRow = {
        medicinename: '',
        batchnumber: '',
        mrp: '',
        quantity: '',
        totalamount: '',
        inventoryid: '',
        prescriptionid: '',
        labname: '',
      };
      setRows((prevRows) => [...prevRows, { ...initialRow }]);
      focusInput("medicinename"); // Focus logic
    };
    

    const focusInput = (inputId) => {
      setTimeout(() => {
        const element = document.getElementById(inputId);
        if (element) {
          element.focus();
        }
      }, 100);
    };
    
    useEffect(() => {
      fetchMedicines();
      fetchInvoiceNumber();
      setRows([{...initialRow}]);
      const currency = getCurrency();
      if(currency == "USD"){
        const uscurrency = '$'
        setCurrency(uscurrency);
      }else{
      setCurrency(currency);
      }
      const add = getAddressInfo();
      setAddressDetails(add);
      var hospitallogo = getLogo();
      //var imagepath = "https://midocfileserver.blob.core.windows.net/midocdev/";
      if(hospitallogo){
        setHospitalLogo(hospitallogo)
      }
      var hospitalname = getHospitalName();
      if(hospitalname){
        setHospitalName(hospitalname)
      }
      
    }, []);

    const handleMedicineNameChange = (id, name, index) => {
      // console.log('name: ', name)
      setInputId(index)
      const newRows = [...rows];
      newRows[index].medicinename = name;
      if (!name) {
        newRows[index] = { ...initialRow }; // Reset the entire row if medicine name is cleared
      }
      setRows(newRows);

      if (name.length >= 3) { // Check if the length of the name is 3 or more characters
        filterMedicineNames(name);
        setShowMedicineNamesDropdown(index);
        setBoolValForSuggestions(!boolValForSuggestions);
      } else {
        setSuggestions([]);
        setShowMedicineNamesDropdown(-1);
        setBoolValForSuggestions(!boolValForSuggestions);
      }
    };

    const FetchBatchList = async () => {
      if(transferMedicineName == "") {
          showErrorToast("Please select any medicine!")
          return;
        }
      var inputForGet = {
        "medicinename": transferMedicineName
      };
      showLoader();
      try {
        var result = await getBatchNumbers(inputForGet);
        // console.log(result.output.data, "batch number call data")
        if (result && result.output.result === "success") {
          setBatchNums(result.output.data);
          setBatchData(result.output.data); // Store the full batch data
        } else {
          setBatchNums([]);
          setBatchData([]);
        }
      } catch (error) {
        console.log(error, "Something went wrong in doctor profile");
      } finally {
        dismissLoader();
      }
    };

    const filterMedicineNames = (medicine) => {
      setTransferMedicineName(medicine)
      const filtered = medicineList.filter((obj) =>
        obj.medicinename?.toLowerCase().includes(medicine.toLowerCase())
      );

      setSuggestions(filtered);
      setBoolValForSuggestions(!boolValForSuggestions);
    };
    const handleBatchNumberChange = (batch, index) => {
      const newRows = [...rows];
      newRows[index].batchnumber = batch;
      setRows(newRows);
    };
    
    const openGenerateReqModal = async (data) => {
      showLoader();
      try {
        const urnData = await getURN({})
        const pharmacyList = getUniqueNames(pharmacyData)
        const date = new Date();
        const formatted = moment(date).format('Do MMMM YYYY');
        const inputFormatted = moment(date).format('YYYY-MM-DD');
        let firstname = localStorage.getItem("firstname");
        let lastname = localStorage.getItem("lastname");
        let fullName = firstname + " " + lastname;
        setSelectedPharmacy({
          pharmacyname: data.pharmacyname || "",
          pharmacyid: data.id || "",
        })
        if(urnData.output.result === "success" && pharmacyList.length > 0) {
          setRequestMedicineData({
            urnNumber: urnData.output?.urn,
            date: formatted,
            inputDate: inputFormatted,
            initiatedBy: fullName,
            pharmacyList: pharmacyList,
            pharmacyName: selectedPharmacy.pharmacyname || "",
          });
          openReqModal.current.openRight();
        }

      } catch(error){
        console.log("Error fetching URN data", error);
      } finally {
        dismissLoader()
      }
    }

    function handlePharmacyChange(name) {
      const selected = resultPharmacy.find(
        item => item.pharmacyname?.trim().toLowerCase() === (name || "").trim().toLowerCase()
      );
      if (selected) {
        setSelectedPharmacy({
          pharmacyname: selected.pharmacyname,
          pharmacyid: selected.id,
        });
      } else {
        setSelectedPharmacy(null);
      }
    }

    const handleSelect = (suggestion, index) => {
      setTransferMedicineName(suggestion.medicinename)
      const newRows = [...rows];
      // newRows[index].medicinename = suggestion.medicinename  + " ("+suggestion.remainingquantity+" Qty)";
      newRows[index].medicinename = suggestion.medicinename;
      newRows[index].medicinenamedisplay = suggestion.medicinename;
      newRows[index].batchnumber = suggestion.batchnumber;
      newRows[index].mrp = suggestion.costperstrip;
      newRows[index].inventoryid = suggestion.inventoryid;
      newRows[index].remainingquantity = suggestion.remainingquantity;
      newRows[index].sgst = suggestion.sgst;
      newRows[index].cgst = suggestion.cgst;
      newRows[index].dosage = suggestion.dosage;
      newRows[index].dosageunit = suggestion.dosageunit;
      newRows[index].medicinetype = suggestion.medicinetype;
      setQuantityInStrip(suggestion.quantityineachstrip);
      calculateTotalAmount(index);
      setRows(newRows);
      setSuggestions([]);
      setShowMedicineNamesDropdown(-1);
      setFocusedItemIndex(-1);  // Reset the focused item index after selection
      focusInput("quantity"); // Focus logic
    };

    const handleBatchSelect = (batch, index) => {
      const newRows = [...rows];
      newRows[index].batchnumber = `${batch.batchnumber} (${batch.remainingquantity} Qty)`;
      newRows[index].inventoryid = batch.inventoryid;
      newRows[index].remainingquantity = batch.remainingquantity; // Store the max quantity
      newRows[index].quantity = batch.remainingquantity; // Auto-populate the quantity
      setRows(newRows);
    };

  const handleQuantityChange = (quantity, index) => {
    const newRows = [...rows];
    
    // Convert to numbers for comparison
    const enteredQty = parseInt(quantity) || 0;
    // const maxQty = parseInt(newRows[index].remainingquantity) || 0;

    if (enteredQty > 0) {
      newRows[index].quantity = quantity;
    } else {
      showErrorToast(`Please enter the quantity`);
      // newRows[index].quantity = maxQty; // Reset to max quantity
    }

    setRows(newRows);
    calculateTotalAmount(index);
    calculateTotalCgstSumForDisplay();
    calculateTotalSgstSumForDisplay();
  };

  const confirmDeleteRow = (index) => {
    setRowToDelete(index);
    deleteRowModal.current.openModal();
  };

  const calculateTotalAmount = (index) => {
    const newRows = [...rows];
    if (QuantityInStrip && newRows[index].mrp) {
      newRows[index].totalamount = ((newRows[index].mrp / QuantityInStrip) * newRows[index].quantity).toFixed(2);
    } else {
      newRows[index].totalamount = ((newRows[index].mrp / 10) * newRows[index].quantity).toFixed(2);
    }
    setRows(newRows);
  };

  const calculateTotalCgstSumForDisplay = () => {
    //const totalCgst = rows.reduce((total, row) => total + parseFloat(row.totalCgst || 0), 0);
    const totalCgst = rows.reduce((total, row) => {
      const totalAmount = parseFloat(row.totalamount || 0);
      const cgstPercentage = parseFloat(row.cgst || 0);
      const cgstValue = (cgstPercentage / 100) * totalAmount;
      return total + cgstValue;
    }, 0);
    return `${currency} ${totalCgst.toFixed(2)}`;
  };

  const calculateTotalSgstSumForDisplay = () => {
    //const totalSgst = rows.reduce((total, row) => total + parseFloat(row.totalSgst || 0), 0);
    const totalSgst = rows.reduce((total, row) => {
      const totalAmount = parseFloat(row.totalamount || 0);
      const sgstPercentage = parseFloat(row.sgst || 0);
      const sgstValue = (sgstPercentage / 100) * totalAmount;
      return total + sgstValue;
    }, 0);
    return `${currency} ${totalSgst.toFixed(2)}`;
  };

  const deleteRowHandler = () => {
    const newRows = rows.filter((_, i) => i !== rowToDelete);
    setRows(newRows);
    deleteRowModal.current.closeModal();
  };

    const handleSaveTransfer = async () => {
      if (!selectedPharmacy.pharmacyname) {
        showErrorToast("Please select a pharmacy");
        return;
      }

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        if (!row.medicinename || row.medicinename.trim() === "") {
          showErrorToast(`Please enter medicine name for row ${i + 1}`);
          return;
        }
        if (!row.quantity || isNaN(row.quantity) || parseInt(row.quantity) <= 0) {
          showErrorToast(`Please enter valid quantity for row ${i + 1}`);
          return;
        }
      }

  
      const medicineDetails = rows.filter(row => row.medicinename && row.quantity).map(row => ({
        inventoryid: row.inventoryid,
        catalogid: row.catalogid,
        quantity: parseInt(row.quantity),
        medicinename: row.medicinename,
        medicinetype: row.medicinetype,
        strength: row.dosage,
        strengthunit: row.dosageunit,
        // batchnumber: row.batchnumber.includes(' (') 
        //   ? row.batchnumber.split(' (')[0] 
        //   : row.batchnumber
      }));
  
      if (medicineDetails.length === 0) {
        showErrorToast("Please add at least one medicine");
        return;
      }
  
      const transferInput = {
        pharmacyid: selectedPharmacy.pharmacyid,
        urn: requestMedicineData.urnNumber || "",
        transferdate: requestMedicineData.inputDate || "",
        medicinedetails: medicineDetails
      };
      showLoader();
      try {
        const result = await GenerateMedicineRequest(transferInput);
        if (result.output.result === "success") {
          setPharmacyData("")
          setSelectedPharmacy("")
          getPharmacyListForReq()
          showSuccessToast("Transfer saved successfully!");
          setRows([{...initialRow}]);
          openReqModal.current.closeRight();
        } else {
          showErrorToast(result.output.message || "Failed to save transfer");
        }
      } catch (error) {
        console.error("Save error:", error);
        showErrorToast("Error saving transfer");
      } finally {
        dismissLoader();
      }
    };
  return (
    <>
      {screenType === "web" ? (
        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            {isLoading && <Loader />}
            <Box w="100%">
              <SecondaryNav customHeader="Pharma Management" />
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  gap="10px"
                  // pl="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by Pharmacy, Address"
                    inputPlace="Search by Pharmacy, Address"
                    id={"searchName"}
                    inputStyleCss={{ w: "350px" }}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => handleChangeName(e)}
                    inputValue={searchValue}
                  />
                  <Box width='400px'>
                  <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Pharmacy Type"
                      options={["IPD", "OPD"]}
                      onClick={handlepharmacytypechangeforfilter}
                      // onClick={handlepharmacytypechange}
                      value={pharmacyTypeFilter}
                    />
                  </Box>
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    onClick={() => handleFilter()}
                    btnStyle={{ m: "0", w: "125px" }}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtnFull"
                    btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                    onClick={() => resetFeilds()}
                  />
                </Box>
                {/* <PrimaryButton
                  buttonText="Partners"
                  onClick={() => navigate("/partners")}
                  variant="mdBtnFull"
                  btnIcon="/assets/svgs/new-tab.svg"
                  iconSrc={true}
                  iconSrcStyle={{ w: "14px" }}
                  btnStyle={{ w: "120px" }}
                  //  isDisabled={actionAccess && !actionAccess.create ? true : false}
                /> */}
                {/* <PrimaryButton
                              buttonText="Transfern"
                              onClick={openTransferModal}
                              // onClick={()=>navigate('/transfermedicines')}
                              variant="mdBtn"
                              btnStyle={{ w: "120px", my: "1rem" }}
                              // isDisabled={actionAccess && !actionAccess.create ? true : false}
                            /> */}
                <PrimaryButton
                  buttonText="Transfer"
                  onClick={openTransferModal}
                  btnStyle={{ m: "0" }}
                  w="125px"
                  //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
                />
                <PrimaryButton
                  buttonText="Add"
                  onClick={openAddPharmacyModal}
                  btnStyle={{ m: "0" }}
                  w="125px"
                  //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
                />
              </Box>
              <Divider />
              {resultPharmacy && resultPharmacy.length > 0 ? (
                <>
                  <Box
                    width="100%"
                    p="1rem"
                    overflow="hidden auto"
                    h="calc(100vh - 155px)"
                  >
                    <SimpleGrid
                      columns={{ base: 1, md: 2, lg: 3, xl: 4 }}
                      spacing="1rem"
                    >
                      {resultPharmacy &&
                        resultPharmacy.map((item, index) => (
                          <Card key={index} borderRadius="10px">
                            <CardBody
                              border="1px solid #E6E7E9"
                              borderRadius="10px"
                            >
                              <Flex
                                w="100%"
                                mb="0.75rem"
                                justifyContent="space-between"
                                alignItems="start"
                              >
                                <Box display="flex" flexDir="column">
                                  <Text fontSize="10px" color="gray.500">
                                    Pharmacy name
                                  </Text>
                                  <Text
                                    fontSize="0.875rem"
                                    title={"item.pharmacyname"}
                                    isTruncated
                                    fontWeight="600"
                                  >
                                    {item.pharmacyname ? item.pharmacyname : "-"}
                                  </Text>
                                </Box>
                                <Box display="flex" gap="10px">
                                  <Box
                                    as="button"
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                    onClick={() => {
                                      openEditPharmacy(item);
                                    }}
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/edit-gray.png"
                                    />
                                  </Box>
                                  <Box
                                    as="button"
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                    onClick={() => {
                                        openDeletePharmacyModal(item);
                                    }}
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/delete.png"
                                    />
                                  </Box>
                                </Box>
                              </Flex>
                              <Box display='flex' gap='2rem'>

                              <Box display="flex" flexDir="column">
                                <Text fontSize="10px" color="gray.500">
                                  {/* Pharmacy Address */}
                                  Pharmacy Type
                                </Text>

                                <Text
                                    fontSize="0.875rem"
                                    title={item.pharmcytype}
                                    isTruncated
                                    fontWeight="600"
                                  >
                                    {item.pharmcytype ? item.pharmcytype : "-"}
                                  </Text>
                                
                                {/* <Text fontSize="0.875rem" fontWeight="600">
                                {item.address1 || item.address2 || item.city || item.state || item.pincode || item.country ? (
                                <>
                                  {item.address1 && `${item.address1}, `}
                                  {item.address2 && `${item.address2}, `}
                                  {item.city && `${item.city}, `}
                                  {item.state && `${item.state}, `}
                                  {item.pincode && `${item.pincode}, `}
                                  {item.country && `${item.country} `}
                                </>
                                ) : '-' }
                                </Text> */}
                              </Box>
                              <Box display="flex" flexDir="column">
                              <Text fontSize="10px" color="gray.500">
                                  Pharmacy Address
                                </Text>

                                <Text
                                    fontSize="0.875rem"
                                    title={item.locationname}
                                    isTruncated
                                    maxW='200px'
                                    fontWeight="600"
                                  >
                                    {item.locationname ? item.locationname : "-"}
                                  </Text>
                              </Box>
                              </Box>

                              <Flex gap='1rem' justifyContent='space-between' mt='1rem' w="100%">
                                <PrimaryButton onClick={()=> navigate('/mastertransferreportbypharmacy?pharmacyid=' + item.id)} variant='grayBtn' btnStyle={{w:'100%', color:"#000"}} buttonText="Transfer report" />
                                <PrimaryButton onClick={()=> navigate('/currentstockbypharmacy?pharmacyid=' + item.id)} variant='grayBtn' btnStyle={{w:'100%', color:"#000"}} buttonText="Stock report" />
                              </Flex>
                                <PrimaryButton onClick={()=> openGenerateReqModal(item)} variant='mdBtn' btnStyle={{w:'100%', mt:"1rem"}} buttonText="Generate Medicine Request" />
                            </CardBody>
                          </Card>
                        ))}
                    </SimpleGrid>
                  </Box>
                </>
              ) : (
                <Box width="100%">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py="2rem"
                  >
                    <Text fontSize="md" fontWeight="bold">
                      No Pharmacy Found
                    </Text>
                  </Box>
                </Box>
              )}
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          <MobileNavbar />
          <MobileSecondaryNav
            header="Pharma Management"
            handlebackarrow={() => navigate(`/profile`)}
          />
          <Box
            w="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p="1rem"
            gap="0.75rem"
            flexDir="column"
          >
            <Flex w='100%' alignItems='center' gap='0.75rem'>
            <SearchBar
              passInputPlace="Search by Pharmacy, Address"
              onKeyDown={handleKeyDown}
              onChange={(e) => handleChangeName(e)}
              handleClick={() => handleFilter()}
              searchValue={searchValue}
              iconSrc={false}
              // placeholderMaxWidth="170px"
            />

            
            {searchValue && searchValue.length > 0 && (
              <PrimaryButton
                buttonText="X"
                id="resetButton"
                variant="grayBtn"
                btnStyle={{ color: "#AA2F27", m: "0", w: "50px" }}
                onClick={() => resetFeilds()}
              />
            )}

             <Box onClick={onToggle}>
              <Image
                w='40px'
                cursor='pointer'
                src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg" }
              />
            </Box>

            </Flex>

            <Collapse in={isOpen} animateOpacity style={{overflow:'visible',width:'100%'}}>
                  <DropdownInput
                    variant="fullSide"
                    dropDownPlace="Pharmacy Type"
                    options={["IPD", "OPD"]}
                    onClick={handlepharmacytypechangeforfilter}
                    menuList={{minW:'150px'}}
                    value={pharmacyTypeFilter}
                  />
                  <Box display='flex' gap='0.75rem' w='100%'>
                      <PrimaryButton
                        buttonText="Transfer"
                        onClick={openTransferModal}
                        variant="mdBtnFull"
                        btnStyle={{ mt: 4 }}
                        />

                      <PrimaryButton
                        buttonText="Add"
                        onClick={openAddPharmacyModal}
                        variant="mdBtnFull"
                        btnStyle={{ mt: 4 }}
                        />
                    <PrimaryButton
                      buttonText="Filter"
                      id="filterButton"
                      variant="mdBtnFull"
                      onClick={() => handleFilter()}
                      btnStyle={{ mt: 4 }}
                    />
                    <PrimaryButton
                      buttonText="Reset"
                      id="resetButton"
                      variant="grayBtnFull"
                      btnStyle={{ color: "#AA2F27", mt: 4 }}
                      onClick={() => resetFeilds()}
                    />
                  </Box>
            </Collapse>
          </Box>
          <Divider />
          {resultPharmacy && resultPharmacy.length > 0 ? (
            <>
              <Box
                width="100%"
                p="1rem"
                overflow="hidden auto"
                h="calc(100vh - 210px)"
              >
                <SimpleGrid
                  columns={1}
                  spacing="0.75rem"
                >
                  {resultPharmacy &&
                    resultPharmacy.map((item, index) => (
                      <Card key={index} borderRadius="10px">
                        <CardBody
                          border="1px solid #E6E7E9"
                          borderRadius="10px"
                        >
                          <Flex
                            w="100%"
                            mb="0.75rem"
                            justifyContent="space-between"
                            alignItems="start"
                          >
                            <Box display="flex" flexDir="column">
                              <Text fontSize="10px" color="gray.500">
                                Pharmacy name
                              </Text>
                              <Text
                                fontSize="0.875rem"
                                title={"item.pharmacyname"}
                                isTruncated
                                fontWeight="600"
                              >
                                {item.pharmacyname ? item.pharmacyname : "-"}
                              </Text>
                            </Box>
                            <Box display="flex" gap="10px">
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                onClick={() => {
                                  openEditPharmacy(item);
                                }}
                              >
                                <Image
                                  w="13px"
                                  src="/assets/imgs/edit-gray.png"
                                />
                              </Box>
                              <Box
                                as="button"
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                                onClick={() => {
                                    openDeletePharmacyModal(item);
                                }}
                              >
                                <Image
                                  w="13px"
                                  src="/assets/imgs/delete.png"
                                />
                              </Box>
                            </Box>
                          </Flex>
                          <Box display='flex' gap='2rem'>

                          <Box display="flex" flexDir="column">
                            <Text fontSize="10px" color="gray.500">
                              {/* Pharmacy Address */}
                              Pharmacy Type
                            </Text>

                            <Text
                                fontSize="0.875rem"
                                title={item.pharmcytype}
                                isTruncated
                                fontWeight="600"
                              >
                                {item.pharmcytype ? item.pharmcytype : "-"}
                              </Text>
                            
                            {/* <Text fontSize="0.875rem" fontWeight="600">
                            {item.address1 || item.address2 || item.city || item.state || item.pincode || item.country ? (
                            <>
                              {item.address1 && `${item.address1}, `}
                              {item.address2 && `${item.address2}, `}
                              {item.city && `${item.city}, `}
                              {item.state && `${item.state}, `}
                              {item.pincode && `${item.pincode}, `}
                              {item.country && `${item.country} `}
                            </>
                            ) : '-' }
                            </Text> */}
                          </Box>
                          <Box display="flex" flexDir="column">
                          <Text fontSize="10px" color="gray.500">
                              Pharmacy Address
                            </Text>

                            <Text
                                fontSize="0.875rem"
                                title={item.locationname}
                                isTruncated
                                maxW='200px'
                                fontWeight="600"
                              >
                                {item.locationname ? item.locationname : "-"}
                              </Text>
                          </Box>
                          </Box>

                          <Flex gap='1rem' justifyContent='space-between' mt='1rem' w="100%">
                            <PrimaryButton onClick={()=> navigate('/mastertransferreportbypharmacy?pharmacyid=' + item.id)} variant='grayBtn' btnStyle={{w:'100%', color:"#000"}} buttonText="Transfer report" />
                            <PrimaryButton onClick={()=> navigate('/currentstockbypharmacy?pharmacyid=' + item.id)} variant='grayBtn' btnStyle={{w:'100%', color:"#000"}} buttonText="Stock report" />
                          </Flex>
                            <PrimaryButton onClick={()=> openGenerateReqModal(item)} variant='mdBtn' btnStyle={{w:'100%', mt:"1rem"}} buttonText="Generate Medicine Request" />
                        </CardBody>
                      </Card>
                    ))}
                </SimpleGrid>
              </Box>
            </>
          ) : (
            <Box width="100%">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py="2rem"
              >
                <Text fontSize="md" fontWeight="bold">
                  No Pharmacy Found
                </Text>
              </Box>
            </Box>
          )}
        </>
      )}

      <ModalRight
        ref={addPharmacyModal}
        header="Add Pharmacy"
        // modalWidth={{ base: "100%", lg: "calc(100vw - 40%)" }}
        modalWidth="460px"
        body={
          <>
            <Box display="flex" gap="1rem" w="100%" py="1rem">

              <Box w="100%">
                {/* <Text mb="1rem" fontSize="1rem" fontWeight="600">
                  Pharmacy Name
                </Text> */}
                <Box w="100%" display="flex">
                  <PrimaryInput
                    inputPlace="Pharmacy Name*"
                    variant=""
                    inputValue={pharmacyName}
                    onChange={(e) => setPharmacyName(e.target.value)}
                  />
                </Box>

                <Box w="100%" display="flex">
                  <PrimaryInput
                    inputPlace="Location*"
                    variant="bothSide"
                    // defaultValue={addressData.address1}
                    inputValue={pharmacyLocation}
                    onChange={(e) => setPharmacyLocation(e.target.value)}
                    maxLength={200}
                  />
                </Box>
                <Box w="100%" display="flex">

                  <RadioGroup 
                          colorScheme="green" 
                          onChange={handlepharmacytypechange} 
                          value={pharmacyType}
                        >
                          <Stack spacing={2} pt="20px" direction="row">
                            <Radio value="IPD">IPD</Radio>
                            <Radio value="OPD">OPD</Radio>
                          </Stack>
                        </RadioGroup>
                  {/* <DropdownInput
                      variant="downSide"
                      dropDownPlace="Pharmacy Type"
                      options={["IPD", "OPD"]}
                      onClick={handlepharmacytypechange}
                      // value={pharmacyType}
                    /> */}
                </Box>
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Add Pharmacy"
                onClick={addPharmacyFunction}
              />
            </Flex>
          </>
        }
      />
      <ModalRight
        ref={editPharmacyModal}
        header="Edit Pharmacy"
        modalWidth="460px"
        body={
          <>
            <Box w="100%" py="1rem">
              
              <Box w="100%" display="flex">
                <PrimaryInput
                  inputPlace="Pharmacy Name*"
                  variant="bothSide"
                  inputValue={pharmacyName}
                  defaultValue={pharmacyName}
                  onChange={(e) => setPharmacyName(e.target.value)}
                />
              </Box>

              <Box w="100%" display="flex">
                <PrimaryInput
                  variant="bothSide"
                  inputPlace="Location*"
                  defaultValue={pharmacyLocation}
                  inputValue={pharmacyLocation}
                  onChange={(e) => setPharmacyLocation(e.target.value)}
                  maxLength={200}
                />
              </Box>

              <Box w="100%" display="flex">
                {/* <DropdownInput
                    variant="downSide"
                    dropDownPlace="Pharmacy Type"
                    options={["IPD", "OPD"]}
                    onClick={handlepharmacytypechange}
                    readOnly={true}
                    value={pharmacyType}
                /> */}

                <RadioGroup 
                          colorScheme="green" 
                          onChange={handlepharmacytypechange} 
                          value={pharmacyType}
                        >
                          <Stack spacing={2} pt="20px" direction="row">
                            <Radio value="IPD">IPD</Radio>
                            <Radio value="OPD">OPD</Radio>
                          </Stack>
                        </RadioGroup>
              </Box>

              
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Edit Pharmacy"
                onClick={editPharmacyFunction}
              />
            </Flex>
          </>
        }
      />

      <DynamicModal
        ref={deletePharmacyModal}
        modalHeader="Delete Pharmacy"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              {/* Are you sure you want to delete Branch "{partnerName}" ? */}
              Are you sure you want to delete "{pharmacyName}" ?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deletePharmacyFromList}
            />
          </>
        }
      />

      <ModalRight
              ref={addTransferModal}
              header="Intra Transfer"
              modalWidth={{ base: "100%", lg: "calc(100vw - 40%)" }}
              body={
                <>
                <TransferIndex
                  onTransferComplete={() => {
                    addTransferModal.current.closeRight()
                  }}
                  getList={() => getPharmacyList()}
                />
                
                </>
              }
            />

      <ModalRight
        ref={openReqModal}
        header="Generate Medicine Request"
        modalWidth={{ base: "100%", lg: "calc(100vw - 40%)" }}
        body={
          <>
            <Flex>
              {/* {isLoading && <Loader />} */}
              <Box
                w="calc(100vw - 6.25rem)"
                display="flex"
                flexDir="column"
                id="print-content"
              >
                <Box>
                    <Box display="flex" mb='1rem' mt='0.875rem' w='100%' flexDirection="row" justifyContent="space-between" alignItems="center" >
                      <Text fontWeight="600" fontSize="1rem">
                        Initiated By: <Box as="span" fontSize='1rem' fontWeight="500">{requestMedicineData.initiatedBy}</Box>  
                      </Text>
                      <Text fontWeight="600" fontSize="1rem">
                        Date: <Box as="span" fontSize='1rem' fontWeight="500">{requestMedicineData.date}</Box> 
                      </Text>
                    </Box>

                    <Box display="flex" flexDir="row">
                      <PrimaryInput
                        type="text"
                        variant="bothSide"
                        inputPlace="URN (Unique Reference Number)"
                        inputValue={requestMedicineData.urnNumber}
                        readOnly
                        width={"30%"}
                        />
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Select Pharmacy"
                        options={requestMedicineData.pharmacyList}
                        value={selectedPharmacy.pharmacyname || ""}
                        onClick={handlePharmacyChange}
                        //   onChange={handlePharmacySelect}
                        readOnly={false}
                        id="pharmacy-select"
                        menuList={{ pos: "absolute", right: "48px", minW: "285px" }}
                      />
                    </Box>
                </Box>

                <Box
                  id="printableDiv2"
                  w="100%"
                  p="1.5rem 0 1.5rem"
                  minH="calc(100vh - 240px)"
                  maxH="calc(100vh - 240px)"
                  overflow="hidden auto"
                >
                  
                    <SimpleTable
                      isTh={false}
                      isDataPresent={true}
                      ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                      footerStyle={{
                        pos: "sticky",
                        bottom: "-1px",
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                      }}
                      tableStyle={{
                        tableLayout: "fixed",
                        width: "100%",
                        border: "1px solid #E6E7E9",
                        borderBottom: "none",
                      }}
                      tableHeaders={
                        <Tr>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            Medicine name
                          </Th>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            Quantity (In Units)
                          </Th>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            <Flex
                              w="100%"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <PrimaryButton
                                btnIcon="/assets/svgs/add-white.svg"
                                iconSrc={true}
                                btnStyle={{ w: "25px", h: "25px", p: "0" }}
                                iconSrcStyle={{ mr: "0", w: "10px" }}
                                onClick={AddAnotherRowPrescription}
                              />
                            </Flex>
                          </Th>
                        </Tr>
                      }
                      tableBody={
                        <>
                          {rows.map((row, index) => (
                            <Tr w="100%" key={index}>
                              <Td p="0">
                                <Box w="100%" pos="relative" cursor="pointer" ref={medicineRef}>
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Medicine name*"
                                    id="medicinename"
                                    inputValue={`${row.medicinename || ''} ${row.dosage || ''} ${row.dosageunit || ''} ${row.medicinetype || ''}`.trim()}
                                    onChange={(e) =>
                                      handleMedicineNameChange(
                                        row.inventoryid,
                                        e.target.value,
                                        index
                                      )
                                    }
                                    inputIdProp={
                                      inputId == index ? "Active" : null
                                    }
                                    boolProp={boolValForSuggestions}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    autocomplete="off"
                                    inputCssStyle={{pr:"36px",_hover:{border: "1px solid", borderRadius: "10px"}}}
                                    maxLength={50}
                                  />
                                  <Image
                                    top="33%"
                                    right="6.5%"
                                    w="15px"
                                    pos="absolute"
                                    src="/assets/imgs/search.png"
                                  />
                                </Box>
                                {/* newly added block of code */}
                                {showMedicineNamesDropdown === index && (
  <Menu isOpen={true}>
    <MenuButton
      as={Box}
      w="100%"
      display="block"
      pos="relative"
      zIndex="999"
    >
      <Box
        pos="absolute"
        top="100%"
        left="0"
        w="100%"
        bg="white"
        borderTop="none"
        border="1px solid #E6E7E9"
        borderRadius="0 0 12px 12px"
      />
    </MenuButton>
    <MenuList
      w="100%"
      borderRadius="0 0 12px 12px"
      zIndex="999"
      bg="white"
      maxH="150px"
      overflow="hidden auto"
      ref={suggestionsMenuRef}
    >
      {suggestions.length > 0 ? (
        suggestions.map((suggestion, sIndex) => (
          <MenuItem
            key={sIndex}
            onClick={() => handleSelect(suggestion, index)}
            cursor="pointer"
            p="1rem"
            py="0.5rem"
            borderBottom="1px solid #E6E7E9"
            bg={focusedItemIndex === sIndex ? "#f0f0f0" : "white"}
          >
            <Text fontSize="0.875rem" fontWeight="500">
              {suggestion.medicinename} {suggestion.dosage} {suggestion.dosageunit} {suggestion.medicinetype}
            </Text>
          </MenuItem>
        ))
      ) : (
        <MenuItem
          disabled
          p="1rem"
          py="0.5rem"
          borderBottom="1px solid #E6E7E9"
        >
          <Text fontSize="0.875rem" fontWeight="500">
            Medicine not found
          </Text>
        </MenuItem>
      )}
    </MenuList>
  </Menu>
)}

                                {/* existing block of code */}
                                {/* {showMedicineNamesDropdown === index &&
                                  suggestions.length > 0 && (
                                    <Menu isOpen={true}>
                                      <MenuButton
                                        as={Box}
                                        w="100%"
                                        display="block"
                                        pos="relative"
                                        zIndex="999"
                                      >
                                        <Box
                                          pos="absolute"
                                          top="100%"
                                          left="0"
                                          w="100%"
                                          bg="white"
                                          borderTop="none"
                                          border="1px solid #E6E7E9"
                                          borderRadius="0 0 12px 12px"
                                        />
                                      </MenuButton>
                                      <MenuList
                                        w="100%"
                                        borderRadius="0 0 12px 12px"
                                        zIndex="999"
                                        bg="white"
                                        maxH="150px"
                                        overflow="hidden auto"
                                        ref={suggestionsMenuRef}
                                      >
                                        {suggestions.map((suggestion, sIndex) => (
                                          <MenuItem
                                            key={sIndex}
                                            onClick={() =>
                                              handleSelect(suggestion, index)
                                            }
                                            cursor="pointer"
                                            p="1rem"
                                            py="0.5rem"
                                            borderBottom="1px solid #E6E7E9"
                                            bg={
                                              focusedItemIndex === sIndex
                                                ? "#f0f0f0"
                                                : "white"
                                            } 
                                          >
                                            <Text
                                              fontSize="0.875rem"
                                              fontWeight="500"
                                            >
                                              {suggestion.medicinename} {suggestion.dosage} {suggestion.dosageunit} {suggestion.medicinetype}
                                            </Text>
                                          </MenuItem>
                                        ))}
                                      </MenuList>
                                    </Menu>
                                  )} */}
                              </Td>
          
                              <Td p="0">
                                <PrimaryInput
                                  ref={quantityRef}
                                  variant="bothSide"
                                  inputPlace="Quantity*"
                                  id="quantity"
                                  inputValue={row.quantity}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only digits (no decimals, no characters)
                                    if (/^\d*$/.test(value)) {
                                      handleQuantityChange(value, index);
                                    }
                                  }}
                                  maxLength={7}
                                  inputCssStyle={{_hover:{border: "1px solid", borderRadius: "10px"}}}
                                />
                              </Td>

                              <Td p="0">
                                <Box
                                  as="button"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  w="100%"
                                  onClick={() => confirmDeleteRow(index)}
                                >
                                  <Image
                                    src="/assets/svgs/delete.svg"
                                    opacity="0.7"
                                  />
                                </Box>
                              </Td>
                            </Tr>
                          ))}
                        </>
                      }
                    />
                  
                  
                </Box>
                            
              </Box>
            </Flex>    
          </>
        }

        footerActions={
            <PrimaryButton buttonText="Generate Request" btnStyle={{width: "200px"}} onClick={handleSaveTransfer} />
        }
      />

      <DynamicModal
        ref={deleteRowModal}
        modalHeader="Delete row"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deleteRowHandler}
            />
          </>
        }
      />
    </>
  );
};

export default PharmacyIndex;
